// The Setup > Data feature (2026-09-20). registry.js imports the page and its sidebar
// icon from here.
import React from "react";

export { default } from "./DataPage";
export { default as DataPage } from "./DataPage";
export { default as SourceCoverageTable } from "./SourceCoverageTable";
export { default as DataFeedsTable } from "./DataFeedsTable";
export { default as EcwStatusCodesCard } from "./EcwStatusCodesCard";

export const feature = "data_page";

// A database/feed glyph — this page is about where the practice's rows come from.
export const dataIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <ellipse cx="12" cy="5" rx="8" ry="3" />
    <path d="M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5" />
    <path d="M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" />
  </svg>
);
